import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons"; // Import the phone icon

const AdvertisementComponent = ({ type }) => {
  const [oddAdd, setOddAdd] = useState([]);
  const [evenAdd, setEvenAdd] = useState([]);
  const [randomAdd, setRandomAdd] = useState([]);

  // Dummy Data (instead of fetching from API)
  const dummyData = [
    {
      name: "KANCHAN",
      description: "<p>सिंगल जोड़ी फीस एडवांस जमा करवानी होगी फरीदाबाद गाजियाबाद गली दिशावर में कंपनी से लीक जोड़ी जो भी भाई अपना लॉस कवर करना चाहते हो गेम सिंगल जोड़ी में ही मिलेगा गेम किसी का बाप काट नहीं सकता अपनी बुकिंग करने के लिए आज ही व्हाट्सएप और कॉल करे.</p>",
      mobile: "91939437140",
      post: "satta king office",
    },
    {
      name: "FOOLCHAND SHUKLA",
      description: "<p>सिंगल जोड़ी फीस एडवांस जमा करवानी होगी फरीदाबाद गाजियाबाद गली दिशावर में कंपनी से लीक जोड़ी जो भी भाई अपना लॉस कवर करना चाहते हो गेम सिंगल जोड़ी में ही मिलेगा गेम किसी का बाप काट नहीं सकता अपनी बुकिंग करने के लिए आज ही व्हाट्सएप और कॉल करे</p>",
      mobile: "0987654321",
      post: "ceo of satta company",
    },
    {
      name: "LALITA NAGAR",
      description: "<p>Leak Report Head BranchGame Paas hum karate hai 100% garanti ke sath agar apko satte se mota paisa kamana hai to abhi sampark kare game lene ke liye call kareTime paas karne ke liye call messege na kareFARIDABAD SATTA KINGADD.</p>",
      mobile: "9887376376",
      post: "satta company",
    },
    {
      name: "HANSRAJ MEENA",
      description: "<p>Leak Report Head Branch FARIDABAD GAZIYABAD GALI DISHAWARJo Bhai Apna Loss Cover Ya , Jis Bhai Ke Upar Karza Ho Gya Ho Wo Bhai Hamse Jude Game Single Jodi Milega Game Kisi Ka Baap Nahi Kaat Sakta BOOKING KRANE KE LIYE SAMPARK KRESATTA COMPANY CEO SATTA KING FIXED ADD.</p>",
      mobile: "9467654745",
      post: "SATTA COMPANY KA BAAP",
    },
    {
      name: "LALITA NAGAR",
      description: "<p>Leak Report Head BranchGame Paas hum karate hai 100% garanti ke sath agar apko satte se mota paisa kamana hai to abhi sampark kare game lene ke liye call kareTime paas karne ke liye call messege na kareFARIDABAD SATTA KINGADD.</p>",
      mobile: "9610551034",
      post: "HEAD OF COMPANY",
    },
  ];

  useEffect(() => {
    // Simulating API call with dummy data
    const odd = [];
    const even = [];
    const random = [];

    // Divide dummy data into three arrays
    dummyData.forEach((item, index) => {
      if (index % 3 === 0) {
        odd.push(item); // Every 3rd item goes into odd
      } else if (index % 3 === 1) {
        even.push(item); // Every 3rd + 1 item goes into even
      } else {
        random.push(item); // Every 3rd + 2 item goes into random
      }
    });

    // Update the state with the categorized data
    setOddAdd(odd);
    setEvenAdd(even);
    setRandomAdd(random);
  }, []);

  // generate whatsapp massanger
  const generateWhatsAppLink = (mobile, name) => {
    const message = `Hello ${name}, I am interested in your advertisement.`;
    return `https://api.whatsapp.com/send?phone=${mobile}&text=${encodeURIComponent(
      message
    )}`;
  };

  // generate call dialer
  const generateCallLink = (mobile) => {
    return `tel:${mobile}`; // The 'tel:' protocol will open the phone dialer with the provided number
  };

  return (
    <div className="advertisementSection">
      {type === "odd" && (
        <div className="row">
          {oddAdd && oddAdd.length > 0 ? (
            oddAdd.map((odd, index) => (
              <div key={index} className="col-md-12 ad-section">
                <div className="col-lg-12">
                  <h3>name: {odd?.name}</h3>
                  <h6
                    className="desc"
                    dangerouslySetInnerHTML={{
                      __html: odd?.description,
                    }}
                  />
                  <h4>Mobile: {odd?.mobile}</h4>
                  <h4>post: {odd?.post}</h4>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        {/* WhatsApp Button */}
                        <a
                          href={generateWhatsAppLink(odd.mobile, odd.name)}
                          target="_blank"
                          className="form-control m-2 btn ad-btn col-md-6 col-sm-12"
                        >
                          <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp Now
                        </a>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        {/* Call Button */}
                        <a
                          href={generateCallLink(odd.mobile)}
                          className="form-control m-2 btn ad-btn col-md-6 col-sm-12"
                        >
                          <FontAwesomeIcon icon={faPhone} /> Call Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
        </div>
      )}

      {type === "even" && (
        <div className="row">
          {evenAdd && evenAdd.length > 0 ? (
            evenAdd.map((even, index) => (
              <div key={index} className="col-am-12 ad-section">
                <div className="col-lg-12">
                  <h3>name: {even?.name}</h3>
                  <h6
                    className="desc"
                    dangerouslySetInnerHTML={{
                      __html: even?.description,
                    }}
                  />
                  <h4>Mobile: {even?.mobile}</h4>
                  <h4>post: {even?.post}</h4>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        {/* WhatsApp Button */}
                        <a
                          href={generateWhatsAppLink(even.mobile, even.name)}
                          target="_blank"
                          className="form-control m-2 btn ad-btn col-md-6 col-sm-12"
                        >
                          <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp Now
                        </a>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        {/* Call Button */}
                        <a
                          href={generateCallLink(even.mobile)}
                          className="form-control m-2 btn ad-btn col-md-6 col-sm-12"
                        >
                          <FontAwesomeIcon icon={faPhone} /> Call Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
        </div>
      )}

      {type === "random" && (
        <div className="row">
          {randomAdd && randomAdd.length > 0 ? (
            randomAdd.map((random, index) => (
              <div key={index} className="col-am-12 ad-section">
                <div className="col-lg-12">
                  <h3>name: {random?.name}</h3>
                  <h6
                    className="desc"
                    dangerouslySetInnerHTML={{
                      __html: random?.description,
                    }}
                  />
                  <h4>Mobile: {random?.mobile}</h4>
                  <h4>post: {random?.post}</h4>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        {/* WhatsApp Button */}
                        <a
                          href={generateWhatsAppLink(
                            random.mobile,
                            random.name
                          )}
                          target="_blank"
                          className="form-control m-2 btn ad-btn col-md-6 col-sm-12"
                        >
                          <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp Now
                        </a>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        {/* Call Button */}
                        <a
                          href={generateCallLink(random.mobile)}
                          className="form-control m-2 btn ad-btn col-md-6 col-sm-12"
                        >
                          <FontAwesomeIcon icon={faPhone} /> Call Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
        </div>
      )}
    </div>
  );
};

export default AdvertisementComponent;
